<template>
  <div class="upload-preview-readPretty">
    <div class="img-item" v-for="(item, index) in values" :key="index" @click="showPicture(index)">
      <img :src="item"/>
    </div>
  </div>
</template>

<script>
import './style.scss'
export default {
  props: {
    values: {
      default: () => ([])
    }
  },
  methods: {
    showPicture (index = 0) {
      this.$createImagePreview({
        imgs: this.values,
        'initial-index': index
      }).show()
      console.log('[log] showPicture =>', index)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
